@if (group) {
  <mat-form-field>
    <input
      matInput
      [ngModel]="value"
      (ngModelChange)="setValue($event)"
      placeholder="Choose a date"
      [ngxMatDatetimePicker]="datepicker"
      [disabled]="group.get('value')!.disabled" />
    <mat-datepicker-toggle matSuffix [for]="$any(datepicker)" [disabled]="group.get('value')!.disabled" />
    <ngx-mat-datetime-picker #datepicker [stepHour]="1" [stepMinute]="1">
      <ngx-mat-datepicker-actions>
        <button mat-stroked-button ngxMatDatepickerApply>
          <span class="material-symbols-outlined">check</span>
        </button>
      </ngx-mat-datepicker-actions>
    </ngx-mat-datetime-picker>
    @if (showHint) {
      <mat-hint>{{ group.get('customFieldType')?.value | customFieldType }}</mat-hint>
    }
  </mat-form-field>
}
